export const initialState = {};

export const getSettings = (state = initialState) => state.settings;
